/* Keep the election announcement accurate on 1 October, including open tabs. */
(() => {
  const startsAt = Date.parse('2026-10-01T00:00:00+09:00');
  const endsAt = Date.parse('2026-11-01T00:00:00+09:00');
  const labels = {
    before: '10/1 0:00 START｜バターサンド総選挙 2026',
    open: '投票受付中｜バターサンド総選挙 2026',
    closed: '投票は終了しました｜バターサンド総選挙 2026'
  };
  const selector = 'a.announcement-bar__link[href*="/pages/buttersand-election-2026"] .announcement-bar__message span';
  let timer;

  function update() {
    clearTimeout(timer);
    const now = Date.now();
    const phase = now < startsAt ? 'before' : now < endsAt ? 'open' : 'closed';
    document.querySelectorAll(selector).forEach((element) => {
      // A manually edited announcement (for example, the result reveal) takes priority.
      if (Object.values(labels).includes(element.textContent.trim())) {
        element.textContent = labels[phase];
      }
    });
    const next = now < startsAt ? startsAt : now < endsAt ? endsAt : 0;
    if (next) timer = setTimeout(update, Math.min(Math.max(next - now, 1), 2147483647));
  }

  update();
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) update();
  });
  window.addEventListener('pageshow', update);
})();
